var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOwnerRestaurant = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-owner-restaurant_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  clipPath: "url(#icon-owner-restaurant_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m2.246 1.865 14.391 14.392a1.456 1.456 0 1 1-2.059 2.059l-3.516-3.576a1.25 1.25 0 0 1-.359-.876v-.216a1.25 1.25 0 0 0-.372-.89l-.454-.42a1.25 1.25 0 0 0-1.164-.29 1.9 1.9 0 0 1-1.819-.493L3.557 8.217C1.577 6.237.85 3.248 2.246 1.865z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "m15.625 1.25-3.017 3.018a2.5 2.5 0 0 0-.733 1.768v.58a.62.62 0 0 1-.183.442l-.442.442m1.25 1.25.442-.442a.63.63 0 0 1 .442-.183h.58a2.5 2.5 0 0 0 1.768-.732l3.018-3.018m-1.562-1.562-3.125 3.125m-6.25 8.437-3.896 3.917a1.563 1.563 0 0 1-2.21-2.21L5 12.813"
}))));
export default SvgIconOwnerRestaurant;